import React, { PropsWithChildren } from "react";

import { ButtonPropsProvider } from "../../Button";
import ButtonSet, { ButtonSetProps } from "../ButtonSet";

export function ActionGroup({ children, ...props }: PropsWithChildren<Omit<ButtonSetProps, "direction">>) {
  return (
    <ButtonSet ghost align="end" {...props}>
      <ButtonPropsProvider size="small">{children}</ButtonPropsProvider>
    </ButtonSet>
  );
}
